// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2ifX8","label":"Category_label__BL50c","content":"Category_content__2tn8Z","header":"Category_header__1qNje","location":"Category_location__Y5aP2"};